import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterFingerprint extends BridgeMethod {

  async openFingerprint(deviceType = 2) {
    try {
      if (deviceType == 1) {
        const r = await invoke('showUsbPermission');
        if (!r) {
          console.error(r, "showUsbPermission error");
        } else {
          console.error(r, "showUsbPermission success");
        }
      }
      await invoke("openFingerprint");
    } catch (error) {
      console.error(error, "openFingerprint error");
    }
  }

  async closeFingerprint() {
    try {
      await invoke("closeFingerprint");
    } catch (error) {
      console.error(error, "closeFingerprint error");
    }
  }

  clearFingerprint() {
    return invoke("clearFingerprint");
  }

  deleteFingerprint(position) {
    return invoke("deleteFingerprint", {
      params: {position},
    });
  }

  getFingerprintFeature(position) {
    return invoke("getFingerprintFeature", {
      params: {position},
    });
  }

  getFingerprintInfo() {
    return invoke("getFingerprintInfo");
  }

  importFingerprint(data, position) {
    return invoke("importFingerprint", {
      params: {data, position},
    });
  }

  getTouchFingerStatus() {
    return invoke("getTouchFingerStatus");
  }

  sleepFingerprint() {
    return invoke("sleepFingerprint");
  }

  wakeUpFingerprint() {
    return invoke("wakeUpFingerprint");
  }

  async startFingerprintRecorder(position, {onResult, onError, onDone}) {
    return invoke("startFingerprintRecorder", {
      params: {
        position,
      },
      on: {
        onFingerprintRecorder: (params) => {
          onResult(params);
        },
        onError: (params) => onError(params),
        onDone: (params) => onDone(params),
      },
    });
  }

  closeFingerprintRecorder() {
    return invoke("closeFingerprintRecorder");
  }

  async startFingerprintSearch({onResult, onError, onDone}) {
    return invoke("startFingerprintSearch", {
      on: {
        onFingerprintSearch: (params) => onResult(params),
        onError: (params) => onError(params),
        onDone: (params) => onDone(params),
      },
    });
  }

  closeFingerprintSearch() {
    return invoke("closeFingerprintSearch");
  }

  onFingerprintChange(callback, {autoStart = true} = {}) {
    return on("onFingerprintChange", callback, {
      isSend: true, params: {
        autoStart
      }
    });
  }

  offFingerprintChange(callback) {
    return cancel("onFingerprintChange", {event: callback, isSend: true});
  }
}

export const flutterFingerprint = new FlutterFingerprint();
